import { Badge, Button, SimpleGrid, Stack } from "@mantine/core"
import { IconChartDots, IconListDetails, IconMail, IconSearch, IconUsers, appIcon } from "atlas_forecasting_app/components/common/icons"
import { RouterLink } from "atlas_forecasting_app/lib/router"
import { CenteredMessage, PageHeader, SectionCard } from "atlas_forecasting_app/components/common/page_elements"

export function AdminHomePage({ currentUser }) {
  const isAdmin = !!currentUser?.roles?.includes("admin")

  if (!currentUser) {
    return <CenteredMessage title="Admin" body="Log in required." />
  }

  if (!isAdmin) {
    return <CenteredMessage title="Admin" body="You don’t have access to this page." />
  }

  return (
    <Stack gap="lg">
      <PageHeader title="Admin" subtitle="Internal tools for Atlas operators." />

      <SimpleGrid cols={{ base: 1, md: 2, xl: 4 }} spacing="lg">
        <SectionCard
          title="Featured questions"
          subtitle="Curate the homepage carousel and manage automated featured forecasts."
          action={<Badge variant="light" color="blue">Homepage</Badge>}
        >
          <Button component={RouterLink} to="/admin/featured-questions" variant="light" leftSection={appIcon(IconChartDots, "inline")}>
            Open featured questions
          </Button>
        </SectionCard>

        <SectionCard
          title="Users"
          subtitle="Search users, inspect balances, and manage roles."
          action={<Badge variant="light" color="red">Admin</Badge>}
        >
          <Button component={RouterLink} to="/admin/users" variant="light" leftSection={appIcon(IconUsers, "inline")}>
            Open users
          </Button>
        </SectionCard>

        <SectionCard
          title="Contact messages"
          subtitle="Review inbound contact form submissions from public and signed-in users."
          action={<Badge variant="light" color="teal">Inbox</Badge>}
        >
          <Button component={RouterLink} to="/admin/contact-messages" variant="light" leftSection={appIcon(IconMail, "inline")}>
            Open contact messages
          </Button>
        </SectionCard>

        <SectionCard
          title="Sidekiq queues"
          subtitle="Open the built-in Sidekiq dashboard focused on queued jobs."
          action={<Badge variant="light" color="orange">Live</Badge>}
        >
          <Button component="a" href="/admin/sidekiq/queues" variant="light" leftSection={appIcon(IconListDetails, "inline")}>
            Open queued jobs
          </Button>
        </SectionCard>

        <SectionCard
          title="Forecast review"
          subtitle="Inspect outcomes, filter failures, and mark triaged failures as reviewed."
          action={<Badge variant="light" color="teal">Triage</Badge>}
        >
          <Button component={RouterLink} to="/admin/forecasts" variant="light" leftSection={appIcon(IconSearch, "inline")}>
            Open forecast review
          </Button>
        </SectionCard>
      </SimpleGrid>
    </Stack>
  )
}
